import PropTypes from 'prop-types';
import React from 'react';
import { smartSplitTitle } from './card';

class TitleCard extends React.Component {
    render() {
        const title = smartSplitTitle(
            this.props.title,
            this.props.truncateModeEnabled
        );
        let footerContent;
        if (this.props.left.content || this.props.right.content) {
            footerContent = (
                <div className="card-footer">
                    <div className="card-footer-left">
                        <div
                            data-toggle="tooltip"
                            data-placement="right"
                            title={this.props.left.title}
                        >
                            {this.props.left.content}
                        </div>
                    </div>
                    <div className="card-footer-right">
                        <div
                            data-toggle="tooltip"
                            title={this.props.right.title}
                        >
                            {this.props.right.content}
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="info">
                <div className="card card-primary level-3">
                    <div className="card-content">
                        <h2 className="headline1"> {title}</h2>
                    </div>
                    {footerContent}
                    {this.props.children}
                </div>
            </div>
        );
    }
}

TitleCard.defaultProps = {
    title: ['Title', 'titley'],
    left: {
        content: null,
        title: '',
    },
    right: {
        content: null,
        title: '',
    },
    truncateModeEnabled: false,
};

TitleCard.propTypes = {
    truncateModeEnabled: PropTypes.bool,
};

export default TitleCard;
